import { useSignal } from '@preact/signals-react'
import { popoverData } from 'Pages/RealTimeHistory/RealTime/@signals'

export default function useErrorPopover() {
	const isOpenPopover = useSignal(null)

	const onClosePopover = () => {
		isOpenPopover.value = null
	}

	const onOpenPopover = (target, info) => {
		isOpenPopover.value = target
		popoverData.value = info
	}


	return {
		isOpenPopover: isOpenPopover.value,
		onOpenPopover,
		onClosePopover,
	}
}